import { render, staticRenderFns } from "./StickyAnchorLinks.vue?vue&type=template&id=1368ed38&"
import script from "./StickyAnchorLinks.vue?vue&type=script&lang=js&"
export * from "./StickyAnchorLinks.vue?vue&type=script&lang=js&"
import style0 from "./StickyAnchorLinks.vue?vue&type=style&index=0&id=1368ed38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports